import {Mapper} from '@s-ui/domain'

const DEFAULT_PAGE = 1
const DEFAULT_SIZE = 30

export class FromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper extends Mapper {
  constructor({config, subscriptionSearchRequestValueObjectFactory}) {
    super()
    this._config = config
    this._subscriptionSearchRequestValueObjectFactory = subscriptionSearchRequestValueObjectFactory
    this._sortFields = this._config.get('SORT_FIELDS')
    this._sortQueryParams = this._config.get('SORT_QUERY_PARAM')
    this._adsListSize = this._config.get('search').ADS_LIST_SIZE
    this._sortOrderAsc = this._config.get('ORDER').ASC
    this._removeMake = false
  }

  _getSortTerm = ({sortBy}) => {
    // dealing with monthly subscription fee sorting field on subscription means using price on request
    if (sortBy === this._sortFields.MONTHLY_SUBSCRIPTION_FEE) return this._sortFields.PRICE.toLowerCase()

    return sortBy?.toLowerCase() || null
  }

  setParams = ({removeMake = false}) => {
    this._removeMake = removeMake
    return this
  }

  map = searchRequestValueObject => {
    const {makeId, page, sortBy, sortOrder} = searchRequestValueObject.toJSON()

    const filters = this._removeMake
      ? {}
      : {
          vehicles: [{makeId}]
        }

    const pagination = {
      page: Number(page) || DEFAULT_PAGE,
      size: this._adsListSize || DEFAULT_SIZE
    }

    return this._subscriptionSearchRequestValueObjectFactory({
      filters,
      pagination,
      sort: {
        order: sortOrder?.toLowerCase() || null,
        term: this._getSortTerm({sortBy})
      }
    })
  }
}
